import { createContext } from 'react';

// Export an empty context
export default createContext({});
